import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";
//import { useNavigate } from "react-router-dom";

interface CreateCampaignFooterProps {
  loading: boolean;
}

const CreateCampaignFooter: FC<CreateCampaignFooterProps> = ({ loading }) => {
 // const navigate = useNavigate();

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
          <Button
            type="default"
            style={{ width: 200 }}
            size="large"
          >
            ยกเลิก
          </Button>
          <Button
            loading={loading}
            htmlType="submit"
            type="primary"
            style={{ width: 200 }}
          size="large"
          >
            บันทึก
          </Button>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default CreateCampaignFooter;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 20px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
`;
